import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, Collapse,CircularProgress,Alert } from '@mui/material';
import ItemDetails from './ItemDetails';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { collection, query, where, getDocs,orderBy } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust the path as needed


const getInitials = (name) => {
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

const getColorFromName = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00FFFFFF)
    .toString(16)
    .toUpperCase();
  return "#" + "00000".substring(0, 6 - c.length) + c;
};

const formatToMyanmarCurrency = (number) => {
  const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
  return `${formattedNumber} MMK`;
};

const ItemList = ({ category, onAddToCart,shopId,productType }) => {
  const [openItem, setOpenItem] = useState(null);
  const [items, setItems] = useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState('');

  useEffect(() => {
    const fetchItems = async () => {
      try{
        if (category) {
          const q = query(collection(db, 'products'), where('category', '==', category),where('shopId','==',shopId),where('productType','==',productType),orderBy('name','asc'));
          const querySnapshot = await getDocs(q);
          const fetchedItems = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setItems(fetchedItems);
          setLoading(false);
        }
      }
      catch(error)
      {
        setError(error);
        setLoading(false);
      }
     
    };
    fetchItems();
  }, [category,productType,shopId]);

  const handleClick = (item) => {
    setOpenItem(openItem === item.id ? null : item.id);
  };

  const handleAddComplete = () => {
    setOpenItem(null); // Close the collapse after adding to cart
  };

  if (!category) return null;

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <List component="div" disablePadding>
      {items.map((item) => (
        <div key={item.id}>
          <ListItem button onClick={() => handleClick(item)}>
            <ListItemAvatar>
              <Avatar style={{ backgroundColor: getColorFromName(item.name) }}>
                {getInitials(item.name)}
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={item.name} secondary={formatToMyanmarCurrency(item.price)} />
          </ListItem>
          <Divider component="li" />
          <Collapse in={openItem === item.id} timeout="auto" unmountOnExit>
            <ItemDetails item={item} onAddToCart={(itemDetails) => {
                onAddToCart(itemDetails);
                handleAddComplete();
              }}  />
          </Collapse>
        </div>
      ))}
    </List>
  );
};

export default ItemList;
